export enum ChartColorScheme {
  Performance = 'performance',
}
